import React from "react";
import { lazy, Suspense } from "react";
import { Box, useMediaQuery } from "@mui/material";

import BackgroundWrinkles1 from "../../assets/BackgroundWrinkles1.svg";
import BackgroundWrinklesLight from "../../assets/backgroundWrinklesLight.svg";

import { useTheme } from "@emotion/react";
import HeroBanner from "./HeroBanner";
import StatsComponent from "../../Utils/StatsComponent/StatsComponent";

const LiveAuctionContainer = lazy(() => import("./LiveAuctionContainer"));
const TrendingNFTContainer = lazy(() => import("./TrendingNFTContainer"));
const TrendingSellerContainer = lazy(() =>
  import("./TrendingSellersContainer")
);

const Home = ({ darkMode }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {!isMobile ? (
        <Box>
          <Box sx={{ position: "relative" }}>
            <Box
              style={{
                position: "fixed",
                height: "100vh",
              }}
            >
              <img
                src={darkMode ? BackgroundWrinkles1 : BackgroundWrinklesLight}
                alt="Wrinkles"
              />
            </Box>
            <Box sx={{ mt: 10 }}>
              <HeroBanner isMobile={false} darkMode={darkMode} />
            </Box>
            {/* Stats */}
            <Box sx={{ mt: 10, mb: 20 }}>
              <StatsComponent darkMode={darkMode} />
            </Box>
            {/* Live Auctions */}
            <Suspense fallback={<div>Loading</div>}>
              <LiveAuctionContainer darkMode={darkMode} />
            </Suspense>

            {/* Trending NFTs */}
            <Suspense fallback={<div>Loading</div>}>
              <TrendingNFTContainer darkMode={darkMode} />
            </Suspense>

            {/* Trending Sellers */}
            <Suspense fallback={<div>Loading</div>}>
              <TrendingSellerContainer darkMode={darkMode} />
            </Suspense>
          </Box>
        </Box>
      ) : (
        <Box sx={{ overflowX: "hidden" }}>
          <Box
            style={{
              position: "relative",
            }}
          >
            <Box
              style={{
                position: "fixed",
                height: "100vh",
              }}
            >
              <img
                src={darkMode ? BackgroundWrinkles1 : BackgroundWrinklesLight}
                alt="Wrinkles"
              />
            </Box>
            {/* Hero Banner */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <HeroBanner isMobile={true} darkMode={darkMode} />
            </Box>
            {/* Stats */}
            <StatsComponent darkMode={darkMode} isMobile={true} />
            {/* Live Auctions */}
            <Suspense fallback={<div>Loading</div>}>
              <LiveAuctionContainer darkMode={darkMode} />
            </Suspense>

            {/* Trending NFTs */}
            <Suspense fallback={<div>Loading</div>}>
              <TrendingNFTContainer darkMode={darkMode} />
            </Suspense>

            {/* Trending Sellers */}
            <Suspense fallback={<div>Loading</div>}>
              <TrendingSellerContainer darkMode={darkMode} />
            </Suspense>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Home;
